<template>
  <div class="card config">
    <div class="config__header">
      <h4 class="title">
        {{ translate('config.title') }}
      </h4>
    </div>

    <div class="config__content">
      <div class="header">
        <div class="header__left">
          <p v-if="config.create_username">{{ translate('config.create_username') }}: {{ config.create_username }}</p>
          <p v-if="config.ts_create">{{ translate('config.ts_created') }}: : {{ config.ts_create !== null ? get_date(config.ts_create) : '' }}</p>
        </div>
        <div class="header__right">
          <p v-if="config.update_username">{{ translate('config.update_username') }}: {{ config.update_username}}</p>
          <p v-if="config.ts_update">{{ translate('config.ts_updated') }}: {{ config.ts_update !== null ? get_date(config.ts_update) : '' }}</p>
        </div>
      </div>

      <textarea v-model="config.config.main"/>
    </div>

    <div class="config__button">
      <button
        class="btn btn-success btn-fill btn-wd"
        @click.prevent="save_config"
      >
        {{ translate('save') }}
      </button>
      <button
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>
</template>
<script>

export default {
  props: ['group', 'config'],

  data () {
    return {

    }
  },
  mounted () {
    console.log(this.config)
  },
  deactivated(){

  },

  computed:{

  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    save_config () {
      this.$http.v1.saveDeviceGroupConfig({...this.group, config: this.config},() => {
          this.global_notify('info', this.translate('config.saved_success'))
          this.$store.dispatch('deviceGroupUpdate')
          this.$emit('close')
      })
    },

  }
}

</script>

<style lang='scss' scoped>

  .config{
    &__header{
      padding: 20px 10px 10px;
      .title{
        font-size: 22px;
        font-weight: 600;
        text-align: center;
      }
    }
    &__content{
      padding: 10px;
      height: 400px;

      .header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        height: 10%;
        p{
          margin: 0;
          font-size: 10px;
        }
      }
      textarea{
        flex: 10;
        width: 100%;
        height: 90%;
        overflow: auto;
        font-size: 16px;
        line-height: 125%;
        &::-webkit-scrollbar{
          width: 10px;
        }
      }
    }
    &__button{
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        margin: 0 5px;
      }
    }
  }
  @media (max-width:600px) {
    .config{
      &__form{
        &-row{
          flex-direction: column;
          &__input{
            width: 100%;
          }
        }
      }
    }
  }

</style>
